import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Typography, Space, Button, Modal ,App} from 'antd';
import {
  LockOutlined,
  SafetyOutlined,
  CreditCardOutlined,
  CheckCircleFilled,
  InfoCircleOutlined
} from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { saveCard,getUserCardList,deleteCard } from '@/api/card';

import { eventBus } from '@/utils/eventBus';
import styles from './YourPaymentMethods.module.scss';
import icon1 from '@/assets/images/组 2456@2x.png';
import icon2 from '@/assets/images/路径 1718@2x.png';
import icon3 from '@/assets/images/路径 1717@2x.png';
import icon4 from '@/assets/images/路径 1710@2x.png';

import icon5 from '@/assets/images/VISA.png';
import icon6 from '@/assets/images/DISCOVER.png';
import icon7 from '@/assets/images/AMERICANEXPRESS.png';
import icon8 from '@/assets/images/MASTERCARD.png';


const { Option } = Select;

interface Icard {
  id: string;
  bank_name: string;
  card_type: string;
  card_number: string;
  exp_month: string;
  exp_year: string;
  cvv: string;
  name: string;
  phone: string;
  is_default: boolean;
}

const YourPaymentMethods: React.FC = () => {

  const dispatch = useAppDispatch();

  //是否是手机端
  const isMobile = useAppSelector((state) => state.searchBar.isMobile);

  const { message } = App.useApp();

  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state) => state.searchBar.yourTownloopSearchValue);

  const [visible, setVisible] = useState(false);


  //卡片列表
  const [cardList, setCardList] = useState<Icard[]>([
    // {
    //   id: '1',
    //   bank_name:'Discover',
    //   card_type:'Credit Card',
    //   card_number: '1234567890123456',
    //   exp_month: '01',
    //   exp_year: '2047',
    //   cvv: '111',
    //   name: 'John Doe',
    //   phone: '1234567890',
    //   is_default: true
    // },

  ]);


  //表单自己处理
  const [form] = Form.useForm();

  //取消弹窗
  const onCancel = () => {
    setVisible(false);
  }

  // 新增卡片
  const addCard = () => {
    form.setFieldsValue({
      id: '',
      bank_name:'',
      card_type:'',
      card_number: '',
      exp_month: '',
      exp_year: '',
      cvv: '',
      name: '',
      phone: '',
      is_default: false
    });

    setVisible(true);

  }


  // 编辑卡片
  // const editCard = (cardInfo: Icard) => {
  //   setIsEdit(true);
  //   form.setFieldsValue({
  //     id: cardInfo.id,
  //     card_number: cardInfo.card_number,
  //     exp_month: cardInfo.exp_month,
  //     exp_year: cardInfo.exp_year,
  //     cvv: cardInfo.cvv,
  //     name: cardInfo.name,
  //     phone: cardInfo.phone
  //   });

  //   setVisible(true);

  // }

  const getUserCardListData = () => {
    getUserCardList().then((res) => {
      console.log(res, 'getUserCardListData res');
      if(res.code === 200){
        setCardList(res.data);
      }
    });
  }

  //提交表单
  const handleOk = () => {
    //debugger
    form
      .validateFields()
      .then(values => {
        console.log('values', values);
        saveCard(values).then((res) => {
          if (res.code == 200) {
            message.success('Card saved successfully');
            getUserCardListData();
          } else {
            message.error(res.msg);
          }
        });
        // values.id = Math.ceil(Math.random() * 100) + '';
        // setCardList([
        //   ...cardList,
        //   values
        // ]);


        setVisible(false);
      }, () => {
      });
  };


  //设置默认卡
  const setDefault = (card: Icard,index: number) => {

    saveCard({...card,is_default:true}).then((res) => {
      if (res.code == 200) {
        message.success('Set Default Success');
        getUserCardListData();
      } else {
        message.error(res.msg);
      }
    });
      
  }

  const Unlink = (card: Icard,index: number) => {
    Modal.confirm({
      title: 'Are you sure you want to unbind the current bank card?',
      content: 'This action cannot be undone.',
      okText: 'Verify',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {

        deleteCard({id:card.id}).then((res) => {
          if (res.code == 200) {
            message.success('Unbind Success');
            getUserCardListData();
          } else {
            message.error(res.msg);
          }
        });
        //这里需要个二次确认

        message.success('Unbind Success');

      },
    });
  }


  //mounted 和unmounted
  useEffect(() => {
    getUserCardListData();
    return () => {
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  }, []);

  //yourTownloopSearchValue关键字的监听
  useEffect(() => {
    console.log('YourPaymentMethods组件yourTownloopSearchValue', yourTownloopSearchValue);

  }, [yourTownloopSearchValue])

  return (
    <div className={styles['payment-box']}>
      {
        cardList.length == 0 ?
          <>
            <div className={styles['payment-header']}>
              <div className={styles['payment-title']}>
                Visa、Mastercard
              </div>
              <div className={styles['payment-encrypt']}>
                <LockOutlined style={{ color: '#2AAD61', marginRight: 4 }} />
                <span>All data has been encrypted.</span>
              </div>
            </div>
            <div className={styles['payment-content']}>
              <img src={icon1} className={styles['payment-illustration']} alt="card" />
              <div className={styles['payment-main-title']}>Save the card for faster checkout</div>
              <div className={styles['payment-desc']}>
                <div>
                  <SafetyOutlined style={{ color: '#2AAD61', marginRight: 4 }} />
                  Secure Payment
                </div>
                <div>
                  <CreditCardOutlined style={{ color: '#2AAD61', marginRight: 4 }} />
                  Convenient Payment
                </div>
              </div>
              <Button
                type="primary"
                className={styles['add-card-btn']}
                onClick={addCard}
              >
                +Add a credit card or debit card
              </Button>
            </div>
          </> :
          <>
            <div className={styles['card-list']}>
              {cardList.map((card,index) => (
                <div className={styles['card-item']} key={card.id}>
                  <div className={styles['card-info']}>
                    {
                        card.bank_name == 'Visa' ?
                        <img src={icon5} className={styles['card-logo']} alt={card.bank_name} />
                        : card.bank_name == 'Discover' ?
                        <img src={icon6} className={styles['card-logo']} alt={card.bank_name} />
                        : card.bank_name == 'Mastercard' ?
                        <img src={icon8} className={styles['card-logo']} alt={card.bank_name} />
                        : card.bank_name == 'American express' ?
                        <img src={icon7} className={styles['card-logo']} alt={card.bank_name} />
                        :''
                        
                    }
                    <div>
                      <div className={styles['card-name']}>{card.bank_name}</div>
                      <div className={styles['card-type']}>{card.card_type}</div>
                      <div className={styles['card-number']}>{card.card_number}</div>
                    </div>
                  </div>
                  <div className={styles['card-actions']}>
                    {card.is_default ? (
                      <button className={styles['default-btn']}>Default</button>
                    ) : (
                      <button 
                      className={styles['set-default-btn']}
                      onClick={() => setDefault(card,index)}
                      >Set As Default</button>
                    )}
                    <button 
                      className={styles['unlink-btn']} 
                      onClick={()=>Unlink(card,index)}
                    >Unlink</button>
                  </div>
                </div>
              ))}
              <div className={styles['add-card-box']} onClick={addCard}>
                <button className={styles['add-card-btn1']}>
                  +
                </button>
                <div 
                  className={styles['add-card-text']}
                  onClick={addCard}
                >Add A New Bank Card</div>
              </div>
            </div>
          </>

      }



      {/* 新增卡的弹窗 */}
      <Modal
        open={visible}
        footer={null}
        onCancel={onCancel}
        width={isMobile ? '90%' : 640}
        centered
        className={styles['add-card-modal']}
      >
        <div className={styles['add-card-title']}>Add a new card</div>
        <div className={styles['add-card-encrypt']}>
          <LockOutlined style={{ color: '#2AAD61', marginRight: 4 }} />
          <span>All data is encrypted {'>'}</span>
        </div>
        <Form
          form={form}
          layout="vertical"
          className={styles['add-card-form']}
          requiredMark={false}
        >

          <Form.Item
            name="id"
            style={{ display: 'none' }}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={<span><b>*</b> Bank Name</span>}
            name="bank_name"
            rules={[{ required: true, message: 'Bank Name' }]}
          >
            <Select placeholder="Month" size="large">
                <Option  value="Visa">
                  Visa
                </Option>
                <Option  value="Discover">
                  Discover
                </Option>
                <Option  value="Mastercard">
                  Mastercard
                </Option>
                <Option  value="American express">
                  American express
                </Option>
            </Select>
          </Form.Item>

          <Form.Item
            label={<span><b>*</b> Card Type</span>}
            name="card_type"
            rules={[{ required: true, message: 'Card Type' }]}
          >
            <Select placeholder="Month" size="large">
                <Option  value="creditCard">
                  Credit Card
                </Option>
                <Option  value="debitCard">
                  Debit Card
                </Option>
            </Select>
          </Form.Item>

          <Form.Item
            className={styles['add-card-form-item']}
            label={<span><b>*</b> Card number</span>}
            name="card_number"
            rules={[{ required: true, message: 'Please enter card number.' }]}
            validateStatus="success"
            style={{ marginBottom: 40 }}
            help={
              <span style={{ color: '#2AAD61', display: 'flex', alignItems: 'center' }}>
                <img src={icon4} alt="" style={{ marginRight: 4, width: 14, height: 14 }} />
                Please enter card number.
              </span>
            }
          >
            <Input
              prefix={<CreditCardOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="Card number"
              suffix={<CheckCircleFilled style={{ color: '#2AAD61' }} />}
              size="large"
            />
          </Form.Item>
          <Space
            size={16}
            style={{ display: 'flex', alignItems: 'center' }}
            className={styles['add-card-form-item']}
          >
            <Form.Item
              label={<span><b>*</b> Expiration date</span>}
              name="exp_month"
              rules={[{ required: true, message: 'Month' }]}
              style={{ flex: 1, marginBottom: 0 }}
            >
              <Select placeholder="Month" size="large">
                {Array.from({ length: 12 }, (_, i) => (
                  <Option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                    {String(i + 1).padStart(2, '0')}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="exp_year"
              rules={[{ required: true, message: 'Year' }]}
              style={{ flex: 1, marginBottom: 0, marginTop: 30 }}
            >
              <Select
                placeholder="Year"
                size="large"
                style={{ width: 100 }}
              >
                {Array.from({ length: 40 }, (_, i) => {
                  const year = 2010 + i + '';
                  return <Option key={year} value={year}>{year}</Option>;
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label={<span><b>*</b> CVV</span>}
              name="cvv"
              rules={[{ required: true, message: 'CVV' }]}
              style={{ flex: 1, marginBottom: 0 }}
            >
              <Input
                placeholder="3-4 digits code"
                size="large"
                maxLength={4}
                suffix={<LockOutlined style={{ color: '#bfbfbf' }} />}
              />
            </Form.Item>
          </Space>
          <Form.Item
            className={styles['add-card-form-item']}
            label={<span><b>*</b> contact information</span>}
          >
            <Space size={16} style={{ display: 'flex' }}>
              <Form.Item
                name="name"
                rules={[{ required: true, message: 'Name' }]}
                style={{ flex: 1, marginBottom: 0 }}
              >
                <Input placeholder="Name" size="large" />
              </Form.Item>
              <Form.Item
                name="phone"
                rules={[{ required: true, message: 'Phone' }]}
                style={{ flex: 1, marginBottom: 0 }}
              >
                <Input placeholder="Phone" size="large" />
              </Form.Item>
            </Space>
          </Form.Item>
          <Form.Item className={styles['card-btn-box']}>
            <Button
              type="primary"
              className={styles['add-card-btn']}
              block={isMobile ? true : false}
              onClick={handleOk}
              size="large"
            >
              Add your card
            </Button>
          </Form.Item>
        </Form>
        <div className={styles['add-card-tip']}>
          <div className={styles['add-card-tip-title']}>
            <img src={icon3} alt="" />
            <span>Temu protects your card information</span>
          </div>
          <div className={styles['add-card-tip-desc']}>
            <div>
              <img src={icon2} alt="" />
              <span>Temu follows the Payment Card Industry Data Security Standard (PCI DSS) when handling card data</span>
            </div>
            <div>
              <img src={icon2} alt="" />
              <span>Card information is secure and uncompromised</span>
            </div>
          </div>
        </div>
      </Modal>
      {/* 新增卡的弹窗 */}
    </div>
  );
};

export default YourPaymentMethods; 